export const GET_DISCLOSURE_REQUIREMENTS_SUCCESS =
    'GET_DISCLOSURE_REQUIREMENTS_SUCCESS';
export const SET_DISCLOSURE_REQUIREMENTS_LOADING =
    'SET_DISCLOSURE_REQUIREMENTS_LOADING';
